import { css } from 'lit';

export const styles = css`
	:host {
		--_sds-icon-size: var(--sds-icon-size, var(--sds-components-icon-md));
		--_sds-icon-color: var(--sds-icon-color, var(--sds-color-text-subtle, var(--sds-color-neutral-text-subtle)));
		--_sds-icon-display: var(--sds-icon-display, inline-block);

		display: var(--_sds-icon-display);
		color: var(--_sds-icon-color);
		block-size: var(--_sds-icon-size);
		inline-size: var(--_sds-icon-size);
		min-inline-size: var(--_sds-icon-size);
	}

	:host([size='lg']) {
		--_sds-icon-size: var(--sds-icon-size, var(--sds-components-icon-lg));
	}

	:host([size='s']), /* Deprecated */
	:host([size='sm']) {
		--_sds-icon-size: var(--sds-icon-size, var(--sds-components-icon-sm));
	}

	:host([data-palette]) {
		--_sds-icon-color: var(--sds-icon-color, var(--sds-color-text-subtle, var(--sds-color-neutral-text-subtle)));
	}

	.sds-icon {
		aspect-ratio: 1;
		display: block;
		width: 100%;
		height: 100%;
		overflow: hidden;
	}
`;
